import { isEmpty } from "_helpers";

// @TODO
// Rebuild
export const buildFilterParams = (filters, column_filter_names) => {
  let filter_url_string = filters.reduce((prev, el) => {
    let param = `${column_filter_names[el["column_id"]]}param`;
    let cond = `${column_filter_names[el["column_id"]]}cond`;

    let filter_keys = Object.keys(el["filter"]);

    if (filter_keys.length < 1) {
      return `${prev}`;
    }

    if (Object.keys(el["filter"]).includes("8")) {
      let filterParam = `${el["filter"]["8"]}|${el["filter"]["8_end"]}`;

      let filter_set = `&${cond}=8&${param}=${filterParam}`;

      return `${prev}${filter_set}`;
    }

    let filterCond = filter_keys[0];
    let filterParam = el["filter"][filter_keys[0]];

    let filter_set = `&${cond}=${filterCond}&${param}=${filterParam}`;

    return `${prev}${filter_set}`;
  }, "");
  return filter_url_string;
};

// Api
// returns true: check passed | false: check failed
export const duplicateFilterCheck = (filters, column_id) => {
  if (!filters) {
    return true;
  }
  if (isEmpty(filters)) {
    return true;
  }

  let duplicateFilterCheck = filters.every((element, index) => {
    if (element["column_id"] === column_id) {
      if (
        Object.keys(element["filter"]).includes("6") ||
        Object.keys(element["filter"]).includes("7")
      ) {
        // Empty or Not Empty filter found
        return false;
      }
    }

    return true;
  });

  return duplicateFilterCheck;
};
